<a (click)="asideService.closeMobileMenu()" [routerLink]="menuItem.url" routerLinkActive="bg-green text-white stroke-white" [ngClass]="{'px-8 justify-start mr-8 rounded-r-full': asideState.type === 'full', 'justify-center max-w-12 rounded-full': asideState.type === 'icons'}"
   class="animate-fade-in flex items-center justify-start gap-2 text-darkGray stroke-darkGray cursor-pointer hover:bg-green hover:text-white hover:stroke-white p-2 "
   >
  <div [innerHTML]="safeIconHtml"></div>
  <span class="font-[400] truncate"   *ngIf="asideState.type === 'full'">{{ menuItem.name }}</span>
</a>
